<template>
  <ValidationProvider
    v-slot="{ errors, classes }"
    ref="validator"
    :rules="'required|phoneNumber'"
    slim
  >
    <div>
      <div class="col-sm-4 col-md-3">
        <input
          v-model="content"
          data-cy="phoneInput"
          :required="required"
          name="phoneNumber"
          :readonly="readonly"
          class="form-control"
          :class="classes"
          type="text"
          @input="onChange"
          @change="onChange"
          @blur="onChange"
        >
        <i
          v-if="showErrorIcon(errors)"
          :title="$t('INPUT_PHONE_NUMBER.INVALID')"
          class="fa fa-times text-danger phone-validation-icon"
        />
        <i
          v-if="showCheckIcon(errors)"
          :title="$t('INPUT_PHONE_NUMBER.VALID')"
          class="fa fa-check text-success phone-validation-icon"
        />
        <i
          v-if="showWarnIcon"
          :title="$t('INPUT_PHONE_NUMBER.VALIDATE_FAILURE')"
          class="fa fa-warning text-danger phone-validation-icon"
        />
        <div
          v-if="errors.length > 0"
          class="text-danger"
        >
          {{ errors[0] }}
        </div>
      </div>
      <label
        v-if="required"
        v-t="'REQUIRED'"
        class="col-sm-3 col-md-3 form-group__label-required-manual"
        :class="classes"
      />
    </div>
  </ValidationProvider>
</template>

<script>
import messages from './locales';
import sharedMessages from '@/core/locales';
import { debounce } from 'lodash';
import { mapActions, mapState } from 'vuex';
import { getStatus } from '@/store/helpers';
import { STATUS_ERROR, STATUS_SUCCESS, STATUS_PENDING } from '@/store/helpers';

export default {
  name: 'InputPhoneNumber',
  model: {
    prop: 'value',
  },
  props: {
    value: {
      type: String,
      default: '+',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    submitted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      content: this.value,
    };
  },
  computed: {
    ...mapState('target', {
      validateTargetNumberStatus: (state) =>
        getStatus(state, 'validateTargetNumber') || {},
    }),
    showWarnIcon() {
      return this.validateTargetNumberStatus.status === STATUS_ERROR && !this.readonly;
    }
  },
  watch: {
    validateTargetNumberStatus(newValue) {
      if (this.readonly) return;
      // If it's a success it means response from the backend, we use that to decide the valid state
      if (newValue.status === STATUS_SUCCESS) {
        const errorArray = newValue.result.error ? [newValue.result.error] : [];
        this.$refs.validator.applyResult({
          errors: errorArray, // array of string errors
          valid: newValue.status == newValue.result.isValid, // boolean state
          failedRules: {}, // should be empty since this is a manual error.
        });
      }

      // A failure on the request IE backend error, should put a special error that it's the warning
      if (newValue.status === STATUS_ERROR) {
        this.$refs.validator.applyResult({
          errors: [newValue.error], // array of string errors
          valid: false, // boolean state
          failedRules: {}, // should be empty since this is a manual error.
        });
      }
    },
    value(newValue) {
      this.content = newValue;
      this.onChange(newValue);
    },
    submitted() {
      this.$refs.validator.validate();
    }
  },
  methods: {
    ...mapActions('target', ['validateTargetNumber']),
    onChange: debounce(async function onChangeDebounce() {
      if (this.content[0] !== '+') {
        this.content = '+' + this.content;
      }
      if (this.content.length > 10 && this.content.length < 16) {
        const numberNoPlus = this.content.substring(1);
        await this.validateTargetNumber(numberNoPlus);
      }
      const validatorErrors = (this.$refs.validator.errors && this.$refs.validator.errors.length > 0);
      this.$emit('value-change', { phoneNumber: this.content, isValid: (this.validateTargetNumberStatus.status === STATUS_SUCCESS && this.validateTargetNumberStatus.result.isValid && !validatorErrors) || this.readonly});
    }, 500),
    showErrorIcon(errors) {
      return this.content && this.content.length > 1 && !this.showWarnIcon && this.validateTargetNumberStatus.status !== STATUS_PENDING && errors && errors.length > 0;
    },
    showCheckIcon(errors) {
      return this.content && this.content.length > 1 && !this.showWarnIcon && this.validateTargetNumberStatus.status !== STATUS_PENDING && (errors == null || errors.length === 0);
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>